import Cities from './cities';
import Provinces from './province';

const Iran = {
  Cities,
  Provinces,
}

export default Iran;